import Alerts from './Alerts';
import Badges from './Badges';
import Modals from './Modals';
import Toastr from './Toastr';
import MsgModal from './MsgModal';

export {
  Alerts, Badges, Modals, Toastr, MsgModal
};



// WEBPACK FOOTER //
// ./src/views/Notifications/index.js